import React, { ReactElement } from 'react';
import { FormGroup, Label, Select } from 'idsk-react-components';
import { useNavigate, useParams } from 'react-router';
import StadiumMaterialuHistoria
  from '../../../../model/legislativnyMaterial/StadiumMaterialuHistoria';
import { useUserContext } from '../../../../context/UserContext';
import LegislativnyMaterialDetail
  from '../../../../model/legislativnyMaterial/LegislativnyMaterialDetail';
import getSprievodnyDokumentRoute from '../../../../function/sprievodnyDokumentRoute';
import { currentStadiumEqualsLatest, isLatestStadium } from '../../../../function/getLatestStadium';
import StadiumMaterialuHistoriaList
  from '../../../../model/legislativnyMaterial/StadiumMaterialuHistoriaList';

interface Props {
  materialDetail: LegislativnyMaterialDetail;
  selectedStadium: StadiumMaterialuHistoria;
  setSelectedStadium: (stadiumUuid: StadiumMaterialuHistoria) => void;
  legMaterialHistoriaList: StadiumMaterialuHistoriaList;
}

const StadiumMaterialuSelect = ({
  materialDetail,
  selectedStadium,
  setSelectedStadium,
  legMaterialHistoriaList,
}: Props): ReactElement => {
  const navigate = useNavigate();
  const { pouzivatel } = useUserContext();
  const {
    type,
    year,
    index,
    // @ts-ignore
  } = useParams<{ type: string, year: number, index: number }>();

  return (
    <FormGroup>
      <Label htmlFor="stadium">Zobraziť dokumenty vo fáze</Label>
      <Select
        id="stadium"
        name="stadium"
        value={selectedStadium?.uuid}
        onChange={({ target }) => {
          const stadium = legMaterialHistoriaList
            ?.historiaRecords.find((element) => element.uuid === target.value);
          setSelectedStadium(stadium);
          navigate(getSprievodnyDokumentRoute(
            pouzivatel,
            materialDetail?.hasOpravnenieSprievodneDokumenty,
            currentStadiumEqualsLatest(materialDetail?.stadium?.hodnota, legMaterialHistoriaList?.historiaRecords),
            isLatestStadium(legMaterialHistoriaList, stadium),
            stadium.uuid,
            type,
            year,
            index,
          ));
        }}
      >
        {(legMaterialHistoriaList?.historiaRecords?.length > 0) ? (
          <>
            {legMaterialHistoriaList?.historiaRecords?.map((record, indexHistoria) => (
              <option key={record.uuid} value={record.uuid}>
                {indexHistoria + 1}. {record.stadium.nazov}
              </option>
            ))}
          </>
        ) : (
          <option key="emptyOption" value="emptyOption" disabled>
            Nenašiel sa žiadny záznam.
          </option>
        )}
      </Select>
    </FormGroup>
  );
};

export default StadiumMaterialuSelect;
